import {React, useEffect, useState} from 'react'

import { Footer, Blog, Possibility, Features, WhatGPT3, Header, FAQ, MiddleWindow} from './containers';
import { CTA, Brand, Navbar,ScrollButton} from './components';
import './App.css'
import catalystLogo from './assets/catalystLogo.png';

let useClickOutside = (handler,elementClass) => {

  useEffect(() => {
      let maybeHandler = (event) => {
              if(event.target.className.toString()==elementClass.toString()){
                  handler();
              }
      };
      document.addEventListener("mousedown", maybeHandler);
         
      return () => {
          document.removeEventListener("mousedown", maybeHandler);
      };
  });
}




const App = () => {
  const[middleWindowTrigger,setMiddleWindowTrigger]=useState(false);
  let middleWindowRef = useClickOutside(() => setMiddleWindowTrigger(false),"outsideMiddleWindow");
  
  return (
    <div className='App'>
        <div >
            <Navbar setMiddleWindowTrigger={setMiddleWindowTrigger}/>
            <Header />
        </div>
        <Brand />
        
        <WhatGPT3 setMiddleWindowTrigger={setMiddleWindowTrigger}/>
        <Features setMiddleWindowTrigger={setMiddleWindowTrigger}/>
        <FAQ />
        <Footer />
        <MiddleWindow trigger={middleWindowTrigger} setTrigger={setMiddleWindowTrigger} ref={middleWindowRef}>
          
        </MiddleWindow>
        <ScrollButton />

    </div>
  )
}

export default App
